export default "__VITE_ASSET__f10127a7__"